"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerFieldFormExtensionDefinition = void 0;
const FormExtensionPluginBase_1 = require("../../PluginType/FormExtension/FormExtensionPluginBase");
const FormExtensionPluginDefinition_1 = require("../../PluginType/FormExtension/FormExtensionPluginDefinition");
const Collection_1 = require("../../Model/Collection");
const configs_1 = require("../../configs/configs");
/**
 * Display or hide a field based on the answer selection in a different field.
 * How to use: the field that must become visible/invisible should contain values for the 2 data attributes specified below.
 */
class TriggerFieldFormExtension extends FormExtensionPluginBase_1.default {
    constructor() {
        super(...arguments);
        this.DEPENDS_ATTRIBUTE = "data-px-depends-on";
        this.APPEARS_ATTRIBUTE = "data-px-appears-on";
        this.TRIGGER_ATTRIBUTE = "data-px-triggered-by";
        this.inputGroups = new Collection_1.default();
    }
    /**
     * @inheritDoc
     */
    initialize(formHandler) {
        return Promise.resolve().then(() => {
            this.form = formHandler.getFormElement();
            this.registerTriggerField();
        });
    }
    /**
     * Find the fields that qualify for the trigger mechanism.
     */
    registerTriggerField() {
        for (let i = 0; i < this.form.elements.length; i++) {
            if (this.form.elements[i].getAttribute(this.DEPENDS_ATTRIBUTE)) {
                let inputContainer = this.form.querySelector(`[${this.TRIGGER_ATTRIBUTE}="${this.form.elements[i].getAttribute(this.DEPENDS_ATTRIBUTE)}"]`);
                let targetAnswers = this.form.querySelectorAll(`[name="${this.form.elements[i].getAttribute(this.DEPENDS_ATTRIBUTE)}"]`);
                for (let j = 0; j < targetAnswers.length; j++) {
                    this.triggerContainerVisibility(targetAnswers[j], inputContainer, this.form.elements[i].getAttribute(this.APPEARS_ATTRIBUTE));
                }
            }
        }
    }
    /**
     * Set listeners for displaying the field and make sure it is correctly displayed on the initial rendering.
     *
     * @param {Node} answer
     * @param {Element} parent
     * @param {string} condition
     */
    triggerContainerVisibility(answer, parent, condition) {
        if (answer.value === condition) {
            answer.addEventListener("change", () => {
                if (parent.classList.contains(configs_1.configs.utilityCSSClasses.isHidden)) {
                    parent.classList.remove(configs_1.configs.utilityCSSClasses.isHidden);
                }
            });
        }
        else {
            answer.addEventListener("change", () => {
                if (!parent.classList.contains(configs_1.configs.utilityCSSClasses.isHidden)) {
                    parent.classList.add(configs_1.configs.utilityCSSClasses.isHidden);
                }
            });
        }
        if (answer.value !== condition && answer.checked) {
            parent.classList.add(configs_1.configs.utilityCSSClasses.isHidden);
        }
    }
}
exports.default = TriggerFieldFormExtension;
exports.TriggerFieldFormExtensionDefinition = new FormExtensionPluginDefinition_1.default({
    id: "trigger_field_form",
    class: TriggerFieldFormExtension
});
